export default __webpack_public_path__ + "static/media/checkMark.d8b462c5.svg";